// extracted by mini-css-extract-plugin
export default {"container":"animated_div-module___container___df3a319e","root":"animated_div-module___root___d79b8291"};